import React, { useEffect, useState } from "react";
import { Table, Modal, Alert, Typography } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import Endpoints from "../../api/endpoints";
import PageRoutes from "../../utils/routes";
import EndpointFunctions from "../../utils/Functions/endpointFunctions";
import { CardBackgroundPresetColumns } from "./CardBackgroundPresetColumns";

const { Paragraph } = Typography;

const CardBackgroundPresets = () => {
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();
  const [tableData, setTableData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  useEffect(() => {
    fetchPresets();
  }, []);

  const fetchPresets = async () => {
    setTableLoading(true);
    const result = await EndpointFunctions.fetchData({
      endpointURL: Endpoints.getAllCardBackgroundPresets,
      axiosPrivate: axiosPrivate,
    });

    if (result.success) {
      setTableData(result.data || []);
      setTableLoading(false);
    } else {
      setTableLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => closeModal());
    }
  };

  const goToUpdatePage = ({ record }) => {
    navigate(`${PageRoutes.updateCardBackgroundPreset}/${record.id}`);
  };

  const deletePreset = ({ record }) => {
    Modal.confirm({
      title: "Preset'i Pasifleştir",
      icon: <ExclamationCircleFilled />,
      content: (
        <div>
          <p>
            <b>{record.name}</b> (ID: {record.id}) preset'i pasifleştirilecek.
          </p>
          <p style={{ color: "#666", fontSize: 13 }}>
            Bu preset'i daha önce seçmiş işletmelerin kartında görsel render
            edilmeye devam eder. Sadece yeni seçim listesinden gizlenir.
            İstersen daha sonra tekrar aktif edebilirsin.
          </p>
        </div>
      ),
      okText: "Pasifleştir",
      cancelText: "Vazgeç",
      okButtonProps: { danger: true },
      onOk() {
        return new Promise((resolve, reject) => {
          EndpointFunctions.deleteRecord({
            recordId: record.id,
            axiosPrivate: axiosPrivate,
            endpointURL: Endpoints.deleteCardBackgroundPreset,
          })
            .then((response) => {
              resolve();
              if (response.success) {
                showModal("Başarılı", "Preset pasifleştirildi.", () =>
                  closeModal()
                );
                fetchPresets();
              } else {
                showModal(response.errorTitle, response.errorMessage, () =>
                  closeModal()
                );
              }
            })
            .catch((err) => {
              showModal("Hata", "İşlem sırasında bir hata oluştu.", () =>
                closeModal()
              );
              reject(err);
            });
        });
      },
    });
  };

  return (
    <div style={{ padding: 16 }}>
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message="Kart Arka Plan Preset Kütüphanesi"
        description={
          <Paragraph style={{ marginBottom: 0 }}>
            İşletmeler kart özelleştirme ekranında bu listeden hazır arka plan
            görseli seçebilir. Görsel oranı <b>350:502</b> (portrait) olmalı,
            min yükseklik 800 piksel, max 5MB. Yüklenen görseller otomatik
            1200×1722 (full) ve 400×574 (thumb) olarak işlenir. Pasifleştirme
            sadece picker listesinden gizler — mevcut kullanıcılar etkilenmez.
          </Paragraph>
        }
      />
      <Table
        rowKey="id"
        dataSource={tableData}
        columns={CardBackgroundPresetColumns(goToUpdatePage, deletePreset)}
        scroll={{ x: true }}
        loading={tableLoading}
        pagination={false}
      />
      <ModalComponent />
    </div>
  );
};

export default CardBackgroundPresets;
